//@flow
import * as React from 'react';
import PlacesSearchBox from 'common/components/core/map/PlacesSearchBox';
import { themr } from 'react-css-themr';
import defaultTheme from './ShiftLocationsInput.scss';
import classnames from 'classnames';
import { AddressLatLng } from 'common/models/internal/AddressLatLng';
import shiftTestIds from 'common/tests/masterManagement/shiftMaster.json';

type Props = {
    timeSlot: DayShift,
    selectedDays: Array<string>,
    theme: Object,
    startLocationPlaceholder: string,
    endLocationPlaceholder: string,
    onSlotChange: () => void
};

class ShiftLocationsInput extends React.PureComponent<Props> {
    onStartLocationChange = (lat, lng, desc) => {
        const { onSlotChange, timeSlot, slotFor } = this.props;
        const { dayOfWeek } = timeSlot;
        const startLocation = AddressLatLng.fromJS({
            latLng: { lat, lng, accuracy: 0 },
            address: desc
        });
        onSlotChange &&
            onSlotChange({
                startLocation,
                slotFor: slotFor || dayOfWeek
            });
    };
    onEndLocationChange = (lat, lng, desc) => {
        const { onSlotChange, timeSlot, slotFor } = this.props;
        const { dayOfWeek } = timeSlot;
        const endLocation = AddressLatLng.fromJS({
            latLng: { lat, lng, accuracy: 0 },
            address: desc
        });
        onSlotChange &&
            onSlotChange({ endLocation, slotFor: slotFor || dayOfWeek });
    };

    onStartLocationClear = () => {
        const { onSlotChange, slotFor, timeSlot } = this.props;
        const { dayOfWeek } = timeSlot;
        onSlotChange?.({
            deleteStartLocation: true,
            slotFor: slotFor || dayOfWeek
        });
    };

    onEndLocationClear = () => {
        const { onSlotChange, slotFor, timeSlot } = this.props;
        const { dayOfWeek } = timeSlot;
        onSlotChange?.({
            deleteEndLocation: true,
            slotFor: slotFor || dayOfWeek
        });
    };

    render() {
        const {
            timeSlot: dayShift,
            theme,
            t,
            column,
            startLocationPlaceholder,
            endLocationPlaceholder
        } = this.props;
        const { startLocation, endLocation } = dayShift;
        const startLocationAddress = startLocation?.getAddressString() || '';
        const endLocationAddress = endLocation?.getAddressString() || '';
        return (
            <div
                className={classnames(theme.shiftLocationWrap, {
                    [theme.column]: column
                })}
            >
                <div
                    className={classnames(theme.fieldGroup, theme.halfWidth)}
                    data-test-id={shiftTestIds.addShift.startLocation}
                >
                    <div className={theme.label}>
                        {t('masterRiderProperties.startLocation')}
                    </div>
                    <PlacesSearchBox
                        className={theme.startLocation}
                        selectedAddress={startLocationAddress}
                        theme={theme}
                        onPlacesChanged={this.onStartLocationChange}
                        onPlacesClear={this.onStartLocationClear}
                        placeholder={startLocationPlaceholder}
                        disabled={false}
                        useDefaultCenter
                    />
                </div>
                <div
                    className={classnames(theme.fieldGroup, theme.halfWidth)}
                    data-test-id={shiftTestIds.addShift.endLocation}
                >
                    <div className={theme.label}>
                        {t('masterRiderProperties.endLocation')}
                    </div>
                    <PlacesSearchBox
                        className={classnames(theme.startLocation)}
                        selectedAddress={endLocationAddress}
                        theme={theme}
                        onPlacesChanged={this.onEndLocationChange}
                        onPlacesClear={this.onEndLocationClear}
                        placeholder={endLocationPlaceholder}
                        disabled={false}
                        useDefaultCenter
                    />
                </div>
            </div>
        );
    }
}

export default themr('ShiftLocationsInput', defaultTheme)(ShiftLocationsInput);
